module.exports = __webpack_public_path__ + "img/11step-02-05-1_ergebnis.4e50cc44.webp";